import { styled } from "../../../../styled-components";

export const ChartTitleContainer = styled.div<{ isCentered: boolean }>`
    display: flex;
    justify-content: ${p => (p.isCentered ? `center` : `space-between`)};
    align-items: center;
    padding: 0 16px;

    margin-bottom: ${p => (p.isCentered ? 12 : 8)}px;

    cursor: pointer;

    .chart-title {
        ${p => p.theme.fontStyles.AccentHeader3};
        color: ${p => p.theme.fgColorDark};
    }

    .chart-title:not(:last-child) {
        padding-right: ${p => p.theme.pageMarginMedium / 2}px;
    }
`;

export const LegendContainer = styled.div`
    margin-top: 4px;

    .legend-item {
        border-bottom: 1px solid ${p => p.theme.separatorColor};
        height: 35px;
        width: 100%;
        display: flex;
        align-items: center;
        color: ${p => p.theme.fgColorOpaque};
    }

    .legend-value {
        margin-left: auto;
        font-weight: 600;
    }

    .legend-title {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
`;

export const LegendColor = styled.div<{ color: string }>`
    width: 12px;
    height: 12px;
    border-radius: 2px;
    margin-right: 12px;
    background-color: ${p => p.color};

    flex-shrink: 0;
`;

export const LegendValue = styled.div``;

export const DetailsAnimationOuter = styled.div`
    width: 100%;
    overflow: hidden;
    position: relative;
    padding: 0 ${p => p.theme.pageMarginMedium}px 0;

    .graph-description {
        color: ${p => p.theme.fgColorMedium};
        margin-bottom: ${p => p.theme.pageMarginMedium / 2}px;
    }

    .graph-description:last-child {
        margin-bottom: 0;
    }
`;

export const DetailsAnimationMiddle = styled.div`
    position: relative;
    overflow: hidden;
    transition: transform 0.3s;

    .show & {
        transform: unset;
    }

    .hidden & {
        transform: translateY(-100%);
    }
`;

export const DetailsContentContainer = styled.div`
    ${p => p.theme.fontStyles.Body5};
    transition: transform 0.3s;

    .show & {
        transform: unset;
    }

    .hidden & {
        transform: translateY(100%);
    }
`;
